import type { ForqSupabaseClient } from './client';
import { normalizeUiLayout, type UiLayout, type UiLayoutGateway } from '@forq/platform-data';
import { SupabaseOperationError } from './errors';

function messageOf(error: { readonly message: string } | null): string {
  return error?.message ?? 'Unknown Supabase error.';
}

/**
 * Kachel-Layout je Mandant + Seite gegen Supabase — damit die vom Admin gesetzte Reihenfolge für ALLE
 * Mitarbeiter des Mandanten gilt (localStorage wäre nur pro Gerät). Ein jsonb je (Mandant, page_key);
 * LESEN jedes Mandantenmitglied, SPEICHERN nur admin.view — getrennt in den beiden RPCs.
 */
export class SupabaseUiLayoutGateway implements UiLayoutGateway {
  constructor(private readonly client: ForqSupabaseClient) {}

  async loadLayout(tenantId: string, pageKey: string): Promise<UiLayout> {
    const { data, error } = await this.client.rpc('ui_layout_get', { p_tenant_id: tenantId, p_page_key: pageKey });
    if (error) throw new SupabaseOperationError('ui.ui_layout_get', messageOf(error));
    return normalizeUiLayout(data ?? {});
  }

  async saveLayout(tenantId: string, pageKey: string, layout: UiLayout): Promise<UiLayout> {
    const normalized = normalizeUiLayout(layout);
    const { error } = await this.client.rpc('ui_layout_save', { p_tenant_id: tenantId, p_page_key: pageKey, p_layout: normalized });
    if (error) throw new SupabaseOperationError('ui.ui_layout_save', messageOf(error));
    return normalized;
  }
}
